import { render, staticRenderFns } from "./LgFinderPageTipoEmpenho.vue?vue&type=template&id=c6273310"
import script from "./LgFinderPageTipoEmpenho.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoEmpenho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports